/**
 *  OPen & close navigation menu
 *  Used in layout/theme.liquid
 */

// Open & close hamburger menu
const openNav = function (param) {
  const nav = document.getElementById('mobile-menu-drawer');
  const navStatus = param.getAttribute('aria-expanded');

  param.classList.toggle('show');
  nav.classList.toggle('hidden');

  if (navStatus != 'true') {
    param.setAttribute('aria-expanded', 'true');
    nav.setAttribute('aria-hidden', 'false');
  } else {
    param.setAttribute('aria-expanded', 'false');
    nav.setAttribute('aria-hidden', 'true');
  }
};

/**
 *  Show & hide dropdown menu
 */
function openDropdown(el, openItem, flag) {
  const dropdown = el.children[1];

  if (dropdown) {
    if (el.classList.contains(flag)) {
      el.classList.remove(flag);
      dropdown.classList.add('hidden');
    } else {
      if (openItem) {
        openItem.classList.remove(flag);
        openItem.children[1].classList.add('hidden');
      }

      el.classList.add(flag);
      dropdown.classList.remove('hidden');

      // Show max 8 items per column (Max 4 columns)
      const childDropdown = dropdown.querySelectorAll('ul').length;
      if (childDropdown < 1) {
        const children = dropdown.querySelectorAll('li').length;
        let columns = Math.floor(children / 8);
        if (children % 8) {
          columns++;
        }
        if (columns > 3) {
          columns = 4;
        }

        const gridClass = 'grid-cols-' + columns;
        dropdown.classList.add(gridClass);
      }
    }
  }
}

document.querySelectorAll('.top-menu > li').forEach((el) => {
  el.addEventListener('click', () => {
    const openSibling = document.querySelector('.top-menu > li.show');
    openDropdown(el, openSibling, 'show');
  });
});

document.querySelectorAll('.child-dropdown > li').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.stopPropagation();
    const openSibling = document.querySelector('.child-dropdown > li.show-child');
    openDropdown(el, openSibling, 'show-child');
  });
});

// Close dropdown when clicking outside
window.onclick = function (e) {
  const showMenu = document.querySelector('#menu-drawer .show');

  if (showMenu && !showMenu.contains(e.target)) {
    showMenu.classList.remove('show');
    showMenu.children[1].classList.add('hidden');
  }
};

// Show current page indicator
const activePage = window.location.pathname;

if (activePage != '/') {
  const navLinks = document.querySelectorAll('.nav-item');

  navLinks.forEach(function (link) {
    if (link.href.includes(activePage) && link.href.substr(-1, 1) != '#') {
      link.classList.add('active');

      if (link.parentElement.classList.contains('dropdown-item')) {
        link.closest('.dropdown').querySelector('.nav-item').classList.add('active');
      }
    }
  });
}

/**
 *  Sticky form
 *  Used in section/sticky-form.liquid
 */
// Show & hide popup form
const togglePopup = function () {
  const form = document.getElementById('popupForm');
  const formStatus = form.getAttribute('aria-hidden');
  const stikyBtn = document.querySelectorAll('.sticky-form-btn');
  form.classList.toggle('active');

  if (formStatus != 'true') {
    form.setAttribute('aria-hidden', 'true');
    stikyBtn.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  } else {
    form.setAttribute('aria-hidden', 'false');
    stikyBtn.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }
};

// Stop popup icon scroll before footer area
const icon = document.getElementById('stickyForm');

document.addEventListener('scroll', function () {
  const iconBottom = icon.getBoundingClientRect().bottom;
  const footerTop = document.getElementById('footer').getBoundingClientRect().top;
  const diff = footerTop - iconBottom;

  if (diff <= 0) {
    icon.style.top = footerTop - 100 + 'px';
  } else {
    icon.style.bottom = '60px';
  }
});

// Form Validation

const dataRegion = document.body.getAttribute('data-region');

const validateInput = input => {
  // Validation logic for each input
  switch (input.getAttribute('placeholder').replace(' ', '-').toLowerCase()) {
    case 'full-name':
      // Validate name
      if (input.value === '') {
        showError(input, 'Please input your name');
        input.classList.add('false');
        return false;
      } else {
        input.setAttribute('validated', 'true');
        return true;
      }
      break;

    case 'zip-code':
    case 'postal-code':
      // Validate zip code
      let zipCodeRegex, errorMsg;

      if (dataRegion == 'ca') {
        zipCodeRegex = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;
        errorMsg = 'Please input correct postal code (i.e. A1B 2C3)';
      } else {
        zipCodeRegex = /^\d{5}(?:-\d{4})?$/;
        errorMsg = 'Please input correct zip code (i.e. 12345)';
      }

      if (input.value === '') {
        showError(input, 'Please input a ' + input.getAttribute('placeholder'));
        input.setAttribute('validated', 'false');
        return false;
      } else if (!zipCodeRegex.test(input.value)) {
        showError(input, errorMsg);
        input.setAttribute('validated', 'false');
        return false;
      } else {
        input.setAttribute('validated', 'true');
        return true;
      }
      break;

    case 'callback-number':
    case 'phone-number':
    case 'phone':
      // Validate phone number
      const phoneNumberRegex = /^[1-9]\d{2}-?\d{3}-?\d{4}$/;

      if (input.value === '') {
        showError(input, 'Please input a phone number');
        input.setAttribute('validated', 'false');
        return false;
      } else if (!phoneNumberRegex.test(input.value)) {
        showError(input, 'Please input a valid phone number');
        input.setAttribute('validated', 'false');
        return false;
      } else {
        input.setAttribute('validated', 'true');
        return true;
      }
      break;

    case 'email':
    case 'email-address':
      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (input.value === '') {
        showError(input, 'Please input an email address');
        input.setAttribute('validated', 'false');
        return false;
      } else if (!emailRegex.test(input.value)) {
        showError(input, 'Please input a valid email address (xxx@xxx.xx)');
        input.setAttribute('validated', 'false');
        return false;
      } else {
        input.setAttribute('validated', 'true');
        return true;
      }
      break;

    default:
      break;
  }
};

const showError = (input, message) => {
  if (input.parentNode.querySelectorAll('.error-message').length <= 0) {
    const errorContainer = document.createElement('div');
    errorContainer.classList.add('error-message');
    input.after(errorContainer);
  }

  input.parentNode.querySelectorAll('.error-message').forEach(error => {
    error.classList.remove('hidden');
    error.innerHTML = message;
  });
}

function formBuilderCallback(formId) {
  document.querySelectorAll('.wscustomcontactform').forEach(form => {
    form.querySelectorAll('.submit-btn').forEach(submitBtn => {
      submitBtn.addEventListener('click', e => {
        form.querySelectorAll('input:not([type=hidden]').forEach((input) => {
          input.removeAttribute('validated');
          input.parentNode.querySelectorAll('.error-message').forEach(error => {
            error.classList.add('hidden');
          });
          if (!validateInput(input)) {
            e.preventDefault();
          }
        });
      });
    });
  });
}
